import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@mui/material/Box/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@mui/material/Container/index.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/web/node_modules/@mui/material/Typography/index.js");
